var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// transition wrapper to fade items in and timeout
import { ClassNames } from '@emotion/react';
import { CSSTransition } from 'react-transition-group';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const defaultProps = {
    enterDelay: false,
    exitDelay: false,
};
const Fade = (props) => {
    const { enterDelay = defaultProps.enterDelay, exitDelay = defaultProps.exitDelay } = props, restProps = __rest(props, ["enterDelay", "exitDelay"]);
    const delayTime = 100;
    const totalDelayTime = enterDelay || exitDelay ? delayTime : 0;
    return (_jsx(ClassNames, { children: ({ css, }) => (_jsx(CSSTransition, Object.assign({}, restProps, { appear: true, classNames: {
                enter: css `
                  opacity: 0;
                  ${enterDelay && `transition-delay: ${delayTime}ms`}
                `,
                enterActive: css `
                  opacity: 1;
                  ${styleUtils.transition('opacity')}
                `,
                exit: css `
                  opacity: 1;
                  ${exitDelay && `transition-delay: ${delayTime}ms`}
                `,
                exitActive: css `
                  opacity: 0;
                  ${styleUtils.transition('opacity')}
                `,
            }, timeout: parseInt(theme.durationDefault, 10) + totalDelayTime }, { children: props.children }))) }));
};
export { Fade };
